import team1 from "./img/Mehedi.png";
import team2 from "./img/Jarif-Huda-Angon.png";
import team3 from "./img/asaf-kakon.jpg";
import team4 from "./img/ishtiuq.png";
import team5 from "./img/Sabbir.jpg";
import team6 from "./img/Nasim.png";
import team7 from "./img/Biswajit.png";
import team10 from "./img/hedayet.png";
import team11 from "./img/Shahajalal.png";

const TeamSlider = [
  {
    id: 1,
    img: team1,
    Tname: "Mehedi Hassan",
    TDegination: "Founder & CEO",
    Tfacebook: "https://www.facebook.com/MhashiqCEO",
    TInstragram: "https://instagram.com/mh_ashiq_?igshid=YmMyMTA2M2Y=",
    Ttwiter: "https://twitter.com/",
    Tlinkdin: "https://www.linkedin.com/in/mh-ashiq/",
  },
  {
    id: 2,
    img: team2,
    Tname: "Jarif Huda Angon",
    TDegination: "Co-Founder & CTO",
    Tfacebook: "https://www.facebook.com/Angon.zarif",
    TInstragram: "https://instagram.com/angon_zarif?igshid=YmMyMTA2M2Y=",
    Ttwiter: "https://twitter.com/",
    Tlinkdin: "https://www.linkedin.com/in/jarif-huda-angon",
  },
  {
    id: 3,
    img: team3,
    Tname: "Asaf Ud Dulla",
    TDegination: "Co-Founder & CMO",
    Tfacebook: "https://www.facebook.com/KakonCMO",
    TInstragram:
      "https://www.instagram.com/invites/contact/?i=1ncexy37anvtz&utm_content=419g8qc",
    Ttwiter: "https://twitter.com/",
    Tlinkdin: "https://www.linkedin.com/in/asaf-ud-dulla-478908187",
  },

  {
    id: 4,
    img: team4,
    Tname: "Ishtiuq Ahmed Chowdhury",
    TDegination: "Graphic & UI/UX Designer",
    Tgmail: "isthiuq@thevirtualbd.com",
  },
  {
    id: 5,
    img: team5,
    Tname: "Sabbir Hossain",
    TDegination: "Sr. Web Developer",
    Tgmail: "sabbir@thevirtualbd.com",
  },
  {
    id: 6,
    img: team7,
    Tname: "Biswajit Sikdar",
    TDegination: "Front-End Developer",
    Tgmail: "sikdar@thevirtualbd.com",
  },
  {
    id: 7,
    img: team6,
    Tname: "Md. Nasim Uddin",
    TDegination: "Digital Marketer",
    Tgmail: "nasim@thevirtualbd.com",
  },

  {
    id: 8,
    img: team10,
    Tname: " Md. Hedayet",
    TDegination: "Cyber Security Expert",
    Tgmail: "hedayet@thevirtualbd.com",
  },
  {
    id: 9,
    img: team11,
    Tname: "Md Shahajalal",
    TDegination: "Assistant Accountant",
    Tgmail: "shahajalal@thevirtualbd.com",
  },
];

export default TeamSlider;
